<form #addCardForm="ngForm" (ngSubmit)="createCvcToken(addCardForm)"
  *ngIf="elementId == 'iframe_cvc_card' " >
  <div class="form-group">
    <span *ngIf="elementId == 'iframe_add_card' && !show_only_cvv">
      <input type="text" required maxlength="100" [(ngModel)]="cardName" name="cardName" class="form-control"
        trim="true" maxlength="100" (focus)="focussed()"
        placeholder="{{(elementId == 'iframe_add_card') ? 'Card Holder Name' :''}}">
    </span>
  </div>

  <ng-container *ngIf="selectValue && selectValue.length>0 && show_only_cvv">
    <div class="col-lg-12 col-xs-12 mt-4 card-list customer-card-list mb-1" [class.themeChanges]="themeChanges">
      <div class="card_list" *ngFor="let data of selectValue; let i=index">
        <div class="pointer py-1" (click)="selectCvcCard(data,i);"
          [ngClass]="{'showCvv': paymentCard == data.source_id}">

          <label [for]="i" class="card-xxx d-flex pointer align-items-center w-100 justify-content-between mb-0"
            style="height: 35px;">
            <p class="mt-3">
              <span class="card-value-xxx">XXXX XXXX XXXX</span><span class="card-value-last">{{data.last4}}</span>
            </p>
            <span class="mb-3 check-value">
              <input type="radio" id="selected_option13" [checked]="paymentCard == data.source_id"
                name="doctorPaymentCard" [value]="data.source_id" class="pointer">
              <label for="selected_option13" class="card-break"></label>
            </span>
          </label>

        </div>
        <div *ngIf="paymentCard == data.source_id" class="addcalss">
          <div class="stripe-card custom-form-stripe-input py-2" id="{{elementId}}" style="height: 40px !important;">
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="stripe-card custom-form-stripe-input py-2" id="{{elementId}}" style="min-height: 56px;"
    [ngClass]="{'d-none': selectValue && selectValue.length>0 && show_only_cvv}"></div>
    <small class="col-lg-12 p-0" *ngIf="show_only_cvv">
      <b class="color-gray">Note:</b>
      <ul style="padding-inline-start: 15px;font-size: 12px;line-height: 20px;">
        <li class="color-gray" *ngIf="payment_failed_first">Recurring Payment will be charged from first card ending with
          {{payment_failed_first}} if the payment fails from this card.</li>
        <li class="color-gray" *ngIf="payment_failed_this">Recurring Payment will be charged from this Backup card if the
          payment fails from first card ending with {{ payment_failed_this}}.</li>
        <li hideIfDecimal class="color-gray">You will be charged <span class="notranslate">
            {{mainService.currency_data.display_logo}}1</span> or <span class="notranslate"> 1%</span> (whichever is
          higher) as an extra transaction fee if you use a non-<span class="notranslate">
            {{mainService.currency_data.country_code}}</span> debit/credit card.</li>
        <li hideIfDecimal class="color-gray" *ngIf="show_authorization_text"><span
            class="notranslate">{{mainService.currency_data.display_logo}}1 </span>will be deducted and reversed to check
          the Card Authorization.</li>
      </ul>
    </small>
    <p *ngIf="cardError" class="text-danger text-start">{{cardError}}</p>
    <button type="reset" #clear_button class="hide">Clear</button>
<button type="submit" #submit_button class="hide">Submit</button>
</form>

<ng-container *ngIf="elementId !== 'iframe_cvc_card'">
  <!-- card stripe option -->
  <div style="font-weight: 600;font-size: 17px;"><label>Payment Method</label></div>
  <div style="border: none;padding: 0;" class="-stripe-card" id="payment-element"></div>

  <!-- Billing Element -->
  <div *ngIf="bankType != 1" class="col-md-12">
    <div style="font-weight: 600;font-size: 17px;margin-top: 20px;"><label>Billing details</label></div>
    <div id="address-element"></div>
  </div>
  @if (show_save_card) {
    <div class="d-flex my-2 align-items-center">
      <input type="checkbox" [(ngModel)]="save_card_as_Default"> 
      <label class="ms-2 mt-2">
        Save as Default
      </label>
    </div>
  }
  <div (click)="confirmPaymentSetUp()" [class.add-card]="themeChanges">
    <button button-primary-auth class="px-5 w-100 mt-3" id="add_payment">{{themeChanges ? 'Continue' : 'Add'}}</button>
  </div>
</ng-container>